import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import classnames from 'classnames'
import './collection-titles.css'
import {
  setArtistsEnabled
} from '../artist-list-container/actions'
import {
  getNavigationBackPathname } from '../navigation/selectors'
import AppLink from '../app-link'

class CollectionTitles extends Component {

  getHref() {
    const {
      id,
      slug,
      titleSlug,
      artist,
      match
    } = this.props

    const url = match ? match.url : '/'
    const hrefSlug = artist ? titleSlug : (slug || id)
    const hrefPostType = artist ? 'artists' : 'collections'
    let href = `${hrefPostType}/${hrefSlug}`

    if (artist) {
      href = `/${href}`
    } else {
      if (url.substr(-1) !== '/') {
        href = `${url}/${href}`
      }
    }

    return href
  }

  handleClick = e => {
    /*
    const url = match ? match.url : '/'
    const hrefSlug = slug || id
    const hrefPostType = artist ? 'artists' : 'collections'
    let href = `${hrefPostType}/${hrefSlug}`

    if (artist && !this.ticking) {
      // Wait, we need to transition the collection out first
      // Fire an action to notify overlay page to leave
      onBack && onBack(`/${href}`)
      this.clearBackTimer()
      this.startBackTimer()

      // A side-effect is we must hide the artists list
      // As this artists page cannot show it underneath
      // If visited via a collection page
      disableArtistList()

    } else {

      if (url.substr(-1) !== '/') {
        href = `${url}/${href}`
      }

      // Otherwise navigate immediately
      history && history.push(href)
    }
    */
  }

  render() {
    const { disabled, pageName, viewMode, visible, artist, page, title, subtitle } = this.props
    const shouldShowTitle = pageName !== 'ARTIST'
    const isSingle = !shouldShowTitle

    if (!title && !subtitle) return null

    let titleEl = (
      <span>
        {shouldShowTitle &&
          <div dangerouslySetInnerHTML={{ __html: title }} className="collection__titles-title text--small-serif"></div>
        }
      </span>
    )

    let subtitleEl = (
      <span>
        <div dangerouslySetInnerHTML={{ __html: subtitle }} className="collection__titles-subtitle text--small"></div>
      </span>
    )

    // Titles can link if not artist page (page)
    // First titles can link if collection page and artist slug exists
    // Cannot link if disabled set (eg. true in subcollection)
    const canLink = !disabled && (!page || artist)

    if (canLink) {
      titleEl = (
        <AppLink to={this.getHref()} className="collection__titles-link">{titleEl}</AppLink>
      )
    }

    let titles = (
      <span>
        {titleEl}
        {subtitleEl}
      </span>
    )

    /*
    let titles = (
      <span>
        {shouldShowTitle &&
          <div className="collection__row-title text--small-serif">
            {title}
          </div>
        }
        <div className="collection__row-subtitle text--small">
          {subtitle}
        </div>
      </span>
    )
    */

    return (
      <div className={classnames({'collection__overlay--page': page, 'collection__overlay--grid': viewMode}, 'collection__overlay')}>
        <div className={classnames({'collection__row-titles--single': isSingle, 'collection__row-titles--page': page, 'collection__row-titles--hidden': !visible}, 'collection__row-titles')}>
          {titles}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    nextPathName: getNavigationBackPathname(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    disableArtistList() {
      dispatch(setArtistsEnabled(false))
    },
    enableArtistList() {
      dispatch(setArtistsEnabled(true))
    }
  }
}

const collectionTitlesWithRouter = withRouter(CollectionTitles)

export default connect(mapStateToProps, mapDispatchToProps)(collectionTitlesWithRouter)



// WEBPACK FOOTER //
// ./src/components/collection-titles/index.js